import React, {useState} from "react";
import Translate from "localization/Translate";
import Button from "../../buttons/Button";
import InputWithKeyboard from "../../formElements/InputWithKeyboard";
import {checkLuhn, getPaybackConf, isCardCode} from "./util";
import {useActionListener} from "redux-action-listener-hook";
import {addErrorAlert} from "../../redux/actions";
import paybackLogoImg from "./img/paybackLogo.png";

const validateCardNumber = (cardNumber) => {
    return !(cardNumber.length !== 16 || !checkLuhn(cardNumber));
}

export default function (props) {
    useActionListener('SCANNER_DETECTED', (dispatch, action) => {
        console.log({useActionListener: action});
        const scannedCode = action.payload;
        if(isCardCode(scannedCode)){
            props.onDone(scannedCode);
        }else{
            dispatch(addErrorAlert('Not a proper Payback card number!'));
        }
    });

    const [inputValue, setInputValue] = useState('');
    const [validationError, setValidationError] = useState(false);
    let validationErrorDisplay;
    if(validationError !== false){
        validationErrorDisplay = (
            <span style={{
                fontSize: "1rem"
            }} className={'errorMessage'}>{validationError}</span>
        );
    }

    let keyboardLayout = "numbers";
    let validationErrorTitle = "Not valid Payback card code";
    let backButton;
    if(props.onBack !== undefined){
        backButton = (
            <div onClick={props.onBack} style={{marginTop: '0.71rem', marginBottom: '0.71rem'}}>
                <Button type="button" className={"largeButton grayButton"} name={<Translate id="back"/>}
                        arrow="left" flencheClass={"flencheSmallLeftBottom grayFlenche"}/>
            </div>
        );
    }

    const paybackConf = getPaybackConf();

    const onInputDone = (value) => {
        if(validateCardNumber(paybackConf.manualCodePrefix + value)){
            props.onDone(paybackConf.manualCodePrefix + value);
        }else {
            if(isCardCode(value)){
                props.onDone(value)
            }else{
                setValidationError(<Translate id={validationErrorTitle}/>)
            }
        }
    }

    return (
        <div style={{
            padding: "0.71rem",
            paddingTop: "12.86rem"
        }}>
            <img src={paybackLogoImg} style={{
                width: "8.57rem",
                position: "absolute",
                top: "3.58rem",
                right: "0.43rem"
            }} alt="paybackCouponImg"/>
            <span className={"boldUppercaseText"} style={{
                fontSize: "1.71rem"
            }}>
                { <Translate id={"Add Payback customer number"}/> }
            </span>
            <br/>
            <InputWithKeyboard
                beforeInput={<div style={{
                    float: "left",
                    marginTop: "0.36rem",
                    padding: "0.86rem 0.71rem 0.79rem 0.71rem",
                    boxSizing: "border-box",
                    fontSize: "1.43rem",
                    width: "7.86rem",
                    backgroundColor: "#d9d9d9",
                    borderRadius: "0.71rem 0 0 0.71rem"
                }}>{paybackConf.manualCodePrefix.slice(0,3) + ' ' + paybackConf.manualCodePrefix.slice(3)}</div>}
                inputClass={""}
                inputStyle={{
                    boxSizing: "border-box",
                    width: "calc(100% - 7.86rem)"
                }}
                inputLabel={"Enter the 10-digit PAYBACK customer number"}
                layout={keyboardLayout}
                onInputChange={setInputValue}
                initialInputValue={inputValue}
                onDone={(value) => {
                    onInputDone(value);
                }}
                controlled={true}
            />

            { validationErrorDisplay }
            <div onClick={() => {
                onInputDone(inputValue);
            }} style={{
                marginTop: '0.71rem',
                marginBottom: '0.71rem',
                float: 'right'
            }}>
                <Button
                    type="button"
                    className={"largeButton fullWidth blueButton"}
                    name={<Translate id="add"/>}
                    arrow={'right'}
                    style={{
                        minWidth: '17.14rem'
                    }}
                />
            </div>
            { backButton }
        </div>
    );
}